import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import Button from '@/components/basicComponents/button';
import { useAuth } from '@/hooks/use-auth';
import { themeVar } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { StatusDescription, StatusTitle, StatusWrapper } from './style';

export const ConfirmationStatus = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleSignOut = () => {
    signOut();
    navigate('/');
  };

  return (
    <>
      <StatusWrapper>
        <ApprovedIcon width={110} height={110} fill={themeVar('font.weak')} />
        <StatusTitle>You're All Set!</StatusTitle>
        <StatusDescription>You can now sign into your account.</StatusDescription>
      </StatusWrapper>
      <Button size="md" onClick={handleSignOut}>
        Sign In
      </Button>
    </>
  );
};
